import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const whatsappChannel = defineChannel({
  id: 'whatsapp',
  icon: 'brand/whatsapp',
} as const satisfies ChannelDefinition);
